import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivateMemberComponent } from './activate-member.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: ActivateMemberComponent, data: { title: 'Activar usaurios' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ActivateMemberRoutingModule { }
